"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformToken = (name, token) => [
    {
        name,
        tokenType: "unit",
        type: "variable",
        value: `${token.px}px`,
    },
];
exports.default = transformToken;
